var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SelectTeam',{attrs:{"tournament-id":_vm.tournamentId},on:{"selectTeam":_vm.selectTeam,"goToNextStep":_vm.goToNextStep}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }